import {
  SearchMaterializedPagesResponse,
  CursorSearch,
} from './src/quickpages-materializedpages-v1-materialized-page-materialized-pages.universal';

export * from './src/quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';

/** @hidden */
export type MaterializedPageSearch = {};

/**
 * Retrieves a list of up to 100 materialized pages, given the specified filtering, search expression, sorting, and cursor paging ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/api/rest/getting-started/api-query-language)).
 * @param search - WQL expression.
 * @internal
 * @documentationMaturity preview
 * @requiredField search
 * @permissionId QUICK_PAGES.MATERIALIZED_PAGE_READ
 * @fqn wix.quickpages.materializedpages.v1.MaterializedPages.SearchMaterializedPages
 */
export declare function searchMaterializedPages(
  search: CursorSearch
): Promise<SearchMaterializedPagesResponse>;
